import FAQItem from "../../components/FAQItem/FAQItem";

import "./FAQ.css";

function FAQ() {
  return (
    <section id="faq" className="faq dark">
      <div className="content wrapper">
        <h2>FAQ</h2>

        <FAQItem question="Что можно охлаждать камнями?">
          <p>
            Камни подходят для напитков, которые не принято разбавлять водой:
          </p>

          <ul>
            <li>виски</li>
            <li>бурбон</li>
            <li>ром</li>
            <li>коньяк</li>
            <li>джин</li>
            <li>ликёры</li>
          </ul>
        </FAQItem>

        <FAQItem question="Камни не поцарапают бокал?">
          <p>Нет.</p>
          <p>Камни проходят шлифовку и не имеют острых граней.</p>
          <p>Тем не менее, мы рекомендуем аккуратно опускать их в бокал.</p>
        </FAQItem>

        <FAQItem question="Как использовать камни?">
          <ul>
            <li>Положите камни в морозильную камеру на 1–2 часа</li>
            <li>Добавьте 2–3 камня в бокал</li>
            <li>Наслаждайтесь напитком</li>
          </ul>
          <p>После использования камни достаточно промыть водой и высушить.</p>
        </FAQItem>

        <FAQItem question="Все ли камни одинаковые?">
          <p>Нет. И в этом их ценность.</p>
          <p>
            Форма, оттенок и текстура каждого камня уникальны, так как это
            натуральный материал.
          </p>
        </FAQItem>

        <FAQItem question="Охлаждают ли разные камни по-разному?">
          <p>Да.</p>
          <p>
            Это связано с природными свойствами камня: плотностью и структурой.
          </p>
          <p>
            Одни камни быстро отдают холод, другие делают это мягче и дольше.
          </p>
          <p>
            Мы рассматриваем это не как «лучше или хуже», а как различие
            ощущений.
          </p>
        </FAQItem>

        <FAQItem question="Как выбрать свои Spirit Stones?">
          <p>
            Чтобы <a href="#catalog">собрать набор</a>, достаточно выбрать класс
            камней и их количество.
          </p>
          <p>
            Выбор конкретного камня необязателен: если он не указан, мы соберём
            случайный набор из камней выбранного класса.
          </p>
          <p>
            Количество камней обычно зависит от объёма напитка и ситуации. Чаще
            всего в бокал кладут 2–3 камня.
          </p>
          <p>
            Если ориентироваться не только на объём, но и на настроение, мы
            предлагаем такие варианты:
          </p>
          <ul>
            <li>3 камня — тихий вечер</li>
            <li>6 камней — уютный разговор</li>
            <li>9 камней — компания</li>
          </ul>
        </FAQItem>

        <FAQItem question="Каждому напитку — свой камень?">
          <p>
            При выборе напитка мы покажем камни, которые считаем удачным
            сочетанием, и отметим их звёздочкой в выпадающем списке.
          </p>
          <p>
            Камни подбираются к напитку не по формуле, а по сочетанию внешнего
            вида, характера охлаждения и общего настроения.
          </p>
          <p>
            Это всего лишь наше мнение: можно прислушаться, а можно смело
            выбрать по-своему.
          </p>
        </FAQItem>

        <FAQItem question="Это настоящий магазин?">
          <p>Нет.</p>
          <p>
            Spirit Stones — это небольшой React-проект, созданный для
            демонстрации идеи, дизайна и интерфейса.
          </p>
        </FAQItem>

        <FAQItem question="Что произойдёт после заказа?">
          <p>
            Вы увидите иллюстрацию вашего набора в виде эмодзи и случайную
            "каменную" фразу для размышлений.
          </p>
        </FAQItem>
      </div>
    </section>
  );
}

export default FAQ;
